import { render, staticRenderFns } from "./attachments-type.vue?vue&type=template&id=66203009&"
import script from "./attachments-type.vue?vue&type=script&lang=js&"
export * from "./attachments-type.vue?vue&type=script&lang=js&"
import style0 from "./attachments-type.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "attachments-type.vue"
export default component.exports